var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('option-row',{attrs:{"title":"ФИАС города:"}},[_vm._v(_vm._s(_vm.cityFiasId || "-"))]),_c('option-row',{attrs:{"title":"ФИАС региона:"}},[_vm._v(_vm._s(_vm.regionFiasId || "-"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }